import { createI18n } from "vue-i18n";
import { DEFAULT_LANG, SUPPORTED_LOCALES } from "@/definition/constants";

const STORAGE_KEY = "study-jp-locale";

export function isSupportedLocale(locale) {
  return SUPPORTED_LOCALES.includes(locale);
}

export function getSavedLocale() {
  const savedLocale = window.localStorage.getItem(STORAGE_KEY);

  return isSupportedLocale(savedLocale) ? savedLocale : DEFAULT_LANG;
}

export function persistLocale(locale) {
  if (!isSupportedLocale(locale)) return;

  window.localStorage.setItem(STORAGE_KEY, locale);
  document.documentElement.lang = locale;
}

export function getI18nLocale() {
  const locale = i18n.global.locale;

  return typeof locale === "string" ? locale : locale.value;
}

export function setI18nLocale(locale) {
  if (!isSupportedLocale(locale)) return;

  if (typeof i18n.global.locale === "string") {
    i18n.global.locale = locale;
  } else {
    i18n.global.locale.value = locale;
  }
  persistLocale(locale);
}

const initialLocale = getSavedLocale();

const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: initialLocale,
  fallbackLocale: DEFAULT_LANG,
  messages: loadLocaleMessages(),
});

persistLocale(initialLocale);

function loadLocaleMessages() {
  const locales = require.context(
    "@/locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );

  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      const localeMessages = locales(key);
      messages[locale] = localeMessages.default || localeMessages;
    }
  });

  return messages;
}

export default i18n;
